export default {
      id: "formation-pratique-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#formation-pratique",
      toString: function () {
        return this.url;
      }
    }